import { useMemo } from 'react';

import type { Bone } from '../../../lib/skeleton/core';
import type { MappingResult } from '../../../lib/recognize/config';
import Row from './Row';
import Section from './Section';

interface MappingInfoProps {
  bone: Bone;
  mapping: MappingResult;
}

export default function MappingInfo({ bone, mapping }: MappingInfoProps) {
  const { role, chain, confidence } = useMemo(() => {
    let foundRole: string | null = null;
    for (const [r, boneRef] of Object.entries(mapping.roleToBone)) {
      if (boneRef === bone.internalRef) {
        foundRole = r;
        break;
      }
    }

    const chainName = mapping.getChainForBone(bone.internalRef);
    const conf = foundRole ? mapping.roleToConfidence[foundRole] ?? null : null;

    return { role: foundRole, chain: chainName, confidence: conf };
  }, [bone.internalRef, mapping]);

  if (!role && !chain) return null;

  return (
    <Section title="Mapping" defaultOpen={false}>
      {role && <Row label="Role" value={role} />}
      {chain && <Row label="Chain" value={chain} />}
      {confidence !== null && (
        <Row label="Confidence" value={`${Math.round(confidence * 100)}%`} />
      )}
    </Section>
  );
}
